import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetOperacoes(isOpen: boolean) {
  return useQuery([URL.CLASSES_OPERACAO.OPERACOES],
    async () => {
      const { data } = await http.get<any, any>(URL.CLASSES_OPERACAO.OPERACOES, {
        params: {
          size: 10000,
        },
      });
      return data as any[];
    },
    {
      enabled: isOpen,
    },
  );
}

export default useGetOperacoes;
